/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import Toastify from 'toastify-js';
import { ToastIcon, ToastType } from '../../core/interfaces/toast';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  /**
   * @constructor
   * @param {TranslateService} _translate
   */
  constructor(private _translate: TranslateService) {}

  /**
   * Configuración por defecto de las notificaciones.
   * @returns {Toastify.Options}
   */
  private get ToastifyOptions(): Toastify.Options {
    return {
      close: true,
      duration: 5000,
      gravity: 'bottom',
      oldestFirst: true,
      position: 'right',
      stopOnFocus: true,
    };
  }

  /**
   * Muestra la notificación en pantalla.
   * @param {string} message_code - Código del mensaje.
   * @param {ToastType} type - Tipo de notificación.
   * @param {ToastIcon} icon - Icono de notificación.
   */
  public showToast(message_code: string, type: ToastType, icon: ToastIcon): void {
    const Message: string = this._translate.instant(message_code);
    //se desactva la primera "X" ya que es redundante y las segunda es la que funciona
    // const AvatarRoute = `../../../../assets/images/Toastify-icons/${icon}-line.svg`;
    Toastify({
      className: `${type} d-print-none`,
      // avatar: AvatarRoute,
      text: Message,
      ...this.ToastifyOptions,
    }).showToast();
  }
}
